import mentorConfirm from '../assets/mentorConfirm.svg'
import { Button } from "@mui/material/";
import buttonSX from './muiStyles/buttonSX.js'
import {useState, useEffect} from "react";
import {useNavigate} from 'react-router-dom'
import firebase from "../firebase";
import {
  getDatabase,
  ref,
  onValue,
} from "firebase/database";


const MentorConfirm = () => {
const navigate = useNavigate(); 

const [firedata, setFiredata] = useState([])

  useEffect(() => {
    const database = getDatabase(firebase);
    const dbRef = ref(database);
    onValue(dbRef, (response) => {
      const newState = [];
      const data = response.val();

      for (let key in data) {
        // pushing the values from the object into our newState array
        newState.push({ personalID: key, data: data[key] });
      }
      setFiredata(newState.pop());
    });
  }, []);

const handleSuccess = () => {
    console.log('your profile')
    navigate(`/personal/${firedata.personalID}`);
}
    return(
        <div className="wrapper">
            <div className="mentorConfirm">
            <img src={mentorConfirm} alt="Mentor hero" />
            <h4>Mentor profile created!</h4>
            <Button
          sx={buttonSX}
          onClick={handleSuccess}
          className="button"
          variant="contained"
        >
          View profile
        </Button>
            </div>
        </div>
    )
}

export default MentorConfirm;